import en from './en';
import ua from './ua';

const lang = {
	en,
	ua,
};

export default lang;
